<template>
  <div>
    <v-card
      style="
        margin-top: 20px;
        margin-right: 10px;
        margin-left: 10px;
        margin-bottom: 30px;
        padding: 10px 30px;
      "
    >
      <v-row no-gutters>
        <v-col cols="12" style="margin-top: 10px; margin-bottom: 20px">
          <div
            style="border-radius: 10px 10px 0 0"
            :class="`d-flex justify-start ${
              wWidth < 769 ? 'flex-column' : 'flex-row'
            }`"
          >
            <v-toolbar-title>
              List Registrasi
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="initDataTable"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip></v-toolbar-title
            >
            <v-divider class="mx-6" inset vertical></v-divider>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <router-link to="/e-catalogue/vendor-registration/form">
                <v-btn
                  outlined
                  small
                  elevation="1"
                  color="indigo"
                  class="indigo--text"
                  style="font-size: 12px; margin-right: 40px"
                >
                  Ajukan Vendor
                </v-btn>
              </router-link>
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-start align-center">
            <div
              style="
                margin-top: 5px;
                margin-bottom: 15px;
                margin-right: 15px;
                width: 120px;
              "
            >
              <v-select
                :disabled="selectedData.length === 0"
                label="Action"
                style="
                  position: relative;
                  top: 12px;
                  margin: 0 15px 0 5px;
                  font-size: 12px;
                "
                v-model="actionValue"
                :items="itemsAction"
                item-text="name"
                item-value="id"
                outlined
                return-id
                dense
                @change="actionSelect"
              ></v-select>
            </div>
            <div
              style="margin-top: 5px; margin-bottom: 15px; margin-right: 10px"
            >
              <v-autocomplete
                v-if="
                  getUserProfile.level.find(({ id }) => id === '41') !==
                  undefined
                "
                v-model="paramAPI.company_id"
                :items="dropdownCompany"
                @change="changeCompany"
                label="- Perusahaan -"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0; height: 42px"
                clearable
              ></v-autocomplete>
              <v-autocomplete
                v-else
                v-model="paramAPI.company_id"
                :items="dropdownCompany"
                @change="changeCompany"
                label="- Perusahaan -"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0; height: 42px"
                :disabled="isDisableCompanyDropdown"
                clearable
              ></v-autocomplete>
            </div>
            <div
              style="
                margin-top: 5px;
                margin-bottom: 15px;
                margin-right: 10px;
                width: 160px;
              "
            >
              <v-autocomplete
                v-model="paramAPI.status"
                :items="dropdownStatus"
                label="- Status -"
                item-text="name"
                item-value="id"
                return-id
                outlined
                dense
                style="margin: 0; height: 42px"
                clearable
              ></v-autocomplete>
            </div>
            <!-- <div
              style="height:42px;margin-top:5px; margin-bottom:15px; margin-right:10px;"
            >
              <v-text-field
                class="ml-1 mr-2"
                dense
                label="Tanggal"
                type="date"
                name="startdate"
                style="height:30px;"
                step="1"
                outlined
                clearable
              />
            </div> -->
            <div
              style="
                margin-left: auto;
                height: 42px;
                width: 320px;
                margin-top: 5px;
                margin-bottom: 15px;
                margin-right: 10px;
              "
            >
              <v-text-field
                v-model="paramAPI.keyword"
                @keyup.enter="searchEnter"
                label="Cari disini"
                type="cari"
                outlined
                dense
                append-icon="mdi-magnify"
              ></v-text-field>
            </div>
          </div>
        </v-col>

        <v-col cols="12">
          <v-data-table
            v-model="selectedData"
            mobile-breakpoint="0"
            class="elevation-1"
            style="cursor: pointer"
            :headers="headersList"
            :items="result"
            @click:row="rowClick"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100, 1000]
            }"
            :server-items-length="totalData"
            :page="paramAPI.page"
            :items-per-page="paramAPI.itemsPerPage"
            @update:page="updatePage"
            @update:items-per-page="updateItemPerPage"
            item-key="id"
            show-select
          >
            <!-- <template v-slot:[`item.no`]="{ index }">
              <div style="width: 25px; font-size: 12px">
                {{ index + 1 }}
              </div>
            </template> -->
            <template v-slot:[`item.status`]="{ item }">
              <td
                :style="`font-size: 12px; color: ${statusColor(item.status)};`"
              >
                {{ statusName(item.status) }}
              </td>
            </template>
            <template v-slot:[`item.request_no`]="{ item }">
              <div style="font-size: 11px; width: 120px">
                {{ item.request_no }}
              </div>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div style="font-size: 12px; min-width: 90px">
                {{ item.name }}
              </div>
            </template>
            <template v-slot:[`item.business_entity`]="{ item }">
              <div style="font-size: 12px; width: 70px">
                {{ businessEntityName(item.business_entity) }}
              </div>
            </template>
            <template v-slot:[`item.phone_number`]="{ item }">
              <div style="font-size: 12px; width: 120px">
                {{ item.phone_number }}
              </div>
            </template>
            <template v-slot:[`item.email`]="{ item }">
              <div style="font-size: 12px; width: 120px">
                {{ item.email }}
              </div>
            </template>
            <template v-slot:[`item.city_name`]="{ item }">
              <div style="font-size: 11px; width: 120px">
                {{ item.city_name }}
              </div>
            </template>
            <template v-slot:[`item.classification_name`]="{ item }">
              <div style="font-size: 12px; width: 120px">
                {{ item.classification_name }}
              </div>
            </template>
            <template v-slot:[`item.created_by_company_name`]="{ item }">
              <div style="font-size: 11px; width: 120px">
                {{ item.created_by_company_name }}
              </div>
            </template>
            <template v-slot:[`item.created_by_name`]="{ item }">
              <div style="font-size: 12px; width: 120px">
                {{ item.created_by_name }}
              </div>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              <div style="font-size: 12px; width: 120px">
                {{ item.created_at }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <div style="position: fixed; bottom: 10px; right: 0">
      <Scanner />
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
// import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  components: {
    Scanner: () => import('../../home/components/Scanner.vue')
  },
  data: () => ({
    wWidth: window.innerWidth,
    proc: buildType.apiURL('proc'),
    eSanqua: buildType.apiURL('esanqua'),
    hrsApi: buildType.apiURL('hrs'),
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      status: null,
      length: 0,
      sortBy: 'created_at',
      sortType: 'desc',
      itemsPerPage: 10,
      company_id: null,
      date: ''
    },
    totalData: 0,
    result: [],
    selected: null,
    loading: true,
    dropdownCompany: [],
    isDisableCompanyDropdown: false,

    itemsAction: [],
    actionValue: 0,
    selectedData: []
  }),
  watch: {
    selectedData() {
      if (this.selectedData.length !== 0) {
        this.itemsAction = [
          { id: 0, name: '' },
          { id: 1, name: 'Delete' }
        ]
      } else {
        this.itemsAction = [{ id: 0, name: '' }]
      }
    },
    'paramAPI.sortBy'() {
      this.getDataFromApi()
    },
    'paramAPI.sortType'() {
      this.getDataFromApi()
    },
    'paramAPI.status'() {
      this.getDataFromApi()
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    headersList() {
      const arr = [
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nomor Registrasi',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama Vendor',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jenis Usaha',
          value: 'business_entity',
          align: 'left',
          sortable: false
        },
        {
          text: 'Email',
          value: 'email',
          align: 'left',
          sortable: false
        },
        {
          text: 'No. Telp',
          value: 'phone_number',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kota',
          value: 'city_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Klasifikasi',
          value: 'classification_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Diajukan Oleh',
          value: 'created_by_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Company',
          value: 'created_by_company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Buat',
          value: 'created_at',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    dropdownStatus() {
      const arr = [
        {
          id: 0,
          name: 'Draft'
        },
        {
          id: 1,
          name: 'Waiting'
        },
        {
          id: 2,
          name: 'Inprogress'
        },
        {
          id: 3,
          name: 'Done'
        },
        {
          id: 4,
          name: 'Cancel'
        }
      ]
      return arr
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    // get latest parameter
    // if (this.getFpbParam != null) {
    //   this.paramAPI = this.getFpbParam
    // }
    setTimeout(async () => {
      await this.getDataFromApi()
      await this.initDropdown()
    }, 200)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    actionSelect(event) {
      switch (event) {
        case 1:
          this.deleteRegistration()
          break
      }
    },
    rowClick(pValue, pSlot) {
      const arrItem = {
        list: this.result
      }
      this.$store.commit('setVendorRegistrationList', arrItem)
      setTimeout(() => {
        this.$router.push(
          `/e-catalogue/vendor-registration/detail/${pValue.id}?idx=${pSlot.index}`
        )
      }, 200)
    },
    async changeCompany(p) {
      this.paramAPI.company_id = p

      this.clearPaging()
      await this.getDataFromApi()
    },
    startDateWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    endDateWatcher() {
      this.clearPaging()
      this.getDataFromApi()
    },
    async initDropdown() {
      await this.getDropdownCompany()
      // await this.getDropdownDepartment()
    },
    async getDropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) =>
          id === '3' || id === '14' || id === '23' || id === '27' || id === '41'
      )
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdownCompany = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
      } else {
        this.dropdownCompanyApi()
      }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = true
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdownCompany = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = Number(data.total_record)
            return (this.result = data.data)
          } else {
            this.totalData = 0
            return (this.result = [])
          }
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    initDataTable() {
      let url = `${this.proc}vendor/registration/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&order_by=${this.paramAPI.sortBy}&order_type=${this.paramAPI.sortType}`
      if (this.paramAPI.company_id !== null) {
        url = url + `&company_id=${this.paramAPI.company_id}`
      }
      if (this.paramAPI.status !== null) {
        url = url + `&status=${this.paramAPI.status}`
      }
      this.url = url
      this.$store.commit('setVendorRegistQuery', this.paramAPI)
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    async searchEnter() {
      await this.getDataFromApi()
    },
    clearPaging() {
      this.paramAPI.page = 1
      this.paramAPI.offset = 0
      this.paramAPI.limit = 10
      this.paramAPI.itemsPerPage = 10
    },
    businessEntityName(val) {
      switch (val) {
        case 1:
          return 'UD'
        case 2:
          return 'CV'
        case 3:
          return 'PT'
        case 4:
          return 'Lain-lain'
      }
    },
    statusName(val) {
      if (val == null) {
        return '-'
      }
      const status = ['Draft', 'Waiting', 'Inprogress', 'Done', 'Cancel']
      return status[val.id]
    },
    statusColor(val) {
      if (val == null) {
        return 'black'
      }
      const color = ['blue', 'orange', 'green', 'green', 'red']
      return color[val.id]
    },
    deleteRegistration() {
      this.showMsgDialog(
        'question',
        `${this.selectedData.length} data akan dihapus secara permanent, Anda yakin ?`,
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.startDelete()
        } else {
          this.actionValue = 0
        }
      })
    },
    async startDelete() {
      const arrSuccess = []
      const arrFail = []
      let i = 0
      while (
        (await new Promise((resolve, reject) => {
          axios
            .delete(
              `${this.proc}vendor/registration/delete/${this.selectedData[i].id}`
            )
            .then((res) => {
              if (res.data.status_code === '00') {
                arrSuccess.push({
                  index: i,
                  msg: res.data.status_msg
                })
              } else {
                arrFail.push({
                  index: i,
                  msg: res.data.status_msg
                })
              }
              resolve(i++)
            })
            .catch((err) => {
              console.log(err)
              arrFail.push({
                index: i,
                msg: 'error'
              })
              reject(new Error(i++))
            })
        })) <
        this.selectedData.length - 1
      ) {
        console.log('cek ' + i)
      }

      this.actionValue = 0
      this.showMsgDialog(
        'success',
        `${arrSuccess.length} data berhasil terhapus <br/> ${arrFail.length} data gagal terhapus pada index [${arrFail}]`,
        false
      )
      return this.getDataFromApi()
    },

    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, input) {
      const settings = {
        position: 'center',
        icon: pModalType,
        html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
        showConfirmButton: true,
        showCancelButton: pBtnCancel,
        cancelButtonText: 'No'
      }

      if (input !== undefined) {
        if (input) {
          Object.assign(settings, {
            inputPlaceholder: 'Tuliskan keterangan',
            input: 'text'
            // inputAttributes: {
            //   autocapitalize: 'false'
            // }
          })
        }
      }

      return new Promise((resolve) => {
        this.$swal.fire(settings).then((r) => {
          resolve(r)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
